// Versie-badge (NavBar + SidebarNav/AppShell tonen dezelfde info).
//
// - version/commit: gezet door de deploy-workflow bij de build (REACT_APP_VERSION,
//   REACT_APP_COMMIT). Lokaal valt hij terug op de vaste basisversie uit package.json.
//   PR's raken package.json "version" niet meer aan (CI keurt dat af).
// - releaseDate/changes: samengevoegd uit de fragmenten in ./changes/*.json door
//   scripts/build-changes.js (draait vóór start/build/test). Voeg per frontend-PR
//   een fragment toe in plaats van hier te schrijven.
import packageJson from "../../package.json";
import samengevoegd from "./changes.generated.json";

export const versionInfo = {
  version: process.env.REACT_APP_VERSION || packageJson.version,
  commit: process.env.REACT_APP_COMMIT || "",
  releaseDate: samengevoegd.releaseDate,
  changes: samengevoegd.changes,
};
